/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBarberShiftIdAppointments200, GetApiBarberShiftIdAppointments400, GetApiBarberShiftIdAppointments401, GetApiBarberShiftIdAppointments403, GetApiBarberShiftIdAppointments404, GetApiBarberShiftIdAppointments500, GetApiBarberShiftIdAppointmentsPathParams, GetApiBarberShiftIdAppointmentsQueryResponse } from "../entities/GetApiBarberShiftIdAppointments";
import { modelsBarberShiftAppointmentsOutputSchema } from "./models/barberShiftAppointmentsOutputSchema";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { z } from "zod/v4";

export const getApiBarberShiftIdAppointmentsPathParamsSchema = z.object({
    "id": z.coerce.number().int().describe("ID смены")
    }) as unknown as z.ZodType<GetApiBarberShiftIdAppointmentsPathParams>

/**
 * @description OK
 */
export const getApiBarberShiftIdAppointments200Schema = z.lazy(() => modelsBarberShiftAppointmentsOutputSchema) as unknown as z.ZodType<GetApiBarberShiftIdAppointments200>

/**
 * @description Bad Request
 */
export const getApiBarberShiftIdAppointments400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftIdAppointments400>

/**
 * @description Unauthorized
 */
export const getApiBarberShiftIdAppointments401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftIdAppointments401>

/**
 * @description Forbidden
 */
export const getApiBarberShiftIdAppointments403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftIdAppointments403>

/**
 * @description Not Found
 */
export const getApiBarberShiftIdAppointments404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftIdAppointments404>

/**
 * @description Internal Server Error
 */
export const getApiBarberShiftIdAppointments500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftIdAppointments500>

export const getApiBarberShiftIdAppointmentsQueryResponseSchema = z.lazy(() => getApiBarberShiftIdAppointments200Schema) as unknown as z.ZodType<GetApiBarberShiftIdAppointmentsQueryResponse>